import React from 'react';
type ButtonVariant = 'primary' | 'secondary' | 'ghost';
type ButtonSize = 'sm' | 'md' | 'lg';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  icon?: React.ReactNode;
  isLoading?: boolean;
  fullWidth?: boolean;
  children: React.ReactNode;
}
export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  icon,
  isLoading = false,
  fullWidth = false,
  children,
  className = '',
  ...props
}) => {
  const baseClasses = 'inline-flex items-center justify-center font-medium rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-9 focus:ring-offset-2';
  const variantClasses = {
    primary: 'bg-indigo-9 text-white hover:bg-indigo-10 active:bg-indigo-11 disabled:bg-gray-8 disabled:text-gray-10',
    secondary: 'bg-white text-gray-12 border border-gray-7 hover:bg-gray-3 active:bg-gray-4 disabled:bg-gray-3 disabled:text-gray-9 disabled:border-gray-6',
    ghost: 'bg-transparent text-gray-11 hover:bg-gray-3 active:bg-gray-4 disabled:text-gray-9'
  };
  const sizeClasses = {
    sm: 'text-sm py-1.5 px-3',
    md: 'text-sm py-2.5 px-5 h-10',
    lg: 'text-base py-3 px-6'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${widthClass} ${className}`} disabled={isLoading || props.disabled} {...props} data-id="element-545">
      {isLoading && <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-current" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-546">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-547"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-548"></path>
        </svg>}
      {!isLoading && icon && <span className="mr-2" data-id="element-549">{icon}</span>}
      {children}
    </button>;
};